import bn from '../JsonLang/bn.json'
export const lang = { ...bn }